<template>
    <div class="home">
        <ContentHeader :disabled="false" :title="lang('groupLeftMenuText0',language)" :tip_text_arr="headerTipArr"/>
        <Card>
            <Spin size="large" fix v-if="readingDataLoading"></Spin>
            <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                {{lang('groupHomeModuleText1',language)}}
            </p>
            <Row>
                <Col span="5" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeReadingText',language)[0]}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgReadingWords.avg}}
                        <span :style="{fontSize:'18px'}">{{lang('groupHomeReadingMonthUnit0',language)}}</span>
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit0',language)}}：</span>
                        {{avgReadingWords.avgDay}}
                        {{lang('groupHomeReadingDayUnit0',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit1',language)}}：</span>
                        {{avgReadingWords.avgWeek}}
                        {{lang('groupHomeReadingDayUnit0',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit2',language)}}：</span>
                        {{avgReadingWords.avgMonth}}
                        {{lang('groupHomeReadingDayUnit0',language)}}
                    </p>
                </Col>

                <Col span="4" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeReadingText',language)[1]}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgReadingCompletedBooks.avg}}
                        <span :style="{fontSize:'18px'}">{{lang('groupHomeReadingMonthUnit1',language)}}</span>
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit0',language)}}：</span>
                        {{avgReadingCompletedBooks.avgDay}}
                        {{lang('groupHomeReadingDayUnit1',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit1',language)}}：</span>
                        {{avgReadingCompletedBooks.avgWeek}}
                        {{lang('groupHomeReadingDayUnit1',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit2',language)}}：</span>
                        {{avgReadingCompletedBooks.avgMonth}}
                        {{lang('groupHomeReadingMonthUnit1',language)}}
                    </p>
                </Col>

                <Col span="5" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeReadingText',language)[2]}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgReadingBooks.avg}}
                        <span :style="{fontSize:'18px'}">{{lang('groupHomeReadingMonthUnit1',language)}}</span>
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit0',language)}}：</span>
                        {{avgReadingBooks.avgDay}}
                        {{lang('groupHomeReadingDayUnit1',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit1',language)}}：</span>
                        {{avgReadingBooks.avgWeek}}
                        {{lang('groupHomeReadingDayUnit1',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit2',language)}}：</span>
                        {{avgReadingBooks.avgMonth}}
                        {{lang('groupHomeReadingMonthUnit1',language)}}
                    </p>
                </Col>

                <Col span="5" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeReadingText',language)[3]}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgReadingBooks.avg}}
                        <span :style="{fontSize:'18px'}">{{lang('groupHomeReadingDayUnit3',language)}}</span>
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit0',language)}}：</span>
                        {{avgReadingBooks.avgDay}}
                        {{lang('groupHomeReadingDayUnit3',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit1',language)}}：</span>
                        {{avgReadingBooks.avgWeek}}
                        {{lang('groupHomeReadingDayUnit3',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit2',language)}}：</span>
                        {{avgReadingBooks.avgMonth}}
                        {{lang('groupHomeReadingDayUnit3',language)}}
                    </p>
                </Col>

                <Col span="5">
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeReadingText',language)[4]}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgReadingTime.avg / 60 | numFilter}}
                        <span :style="{fontSize:'18px'}">{{lang('groupHomeReadingMonthUnit2',language)}}</span>
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit0',language)}}：</span>
                        {{avgReadingTime.avgDay}}
                        {{lang('groupHomeReadingDayUnit2',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit1',language)}}：</span>
                        {{avgReadingTime.avgWeek}}
                        {{lang('groupHomeReadingDayUnit2',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit2',language)}}：</span>
                        {{avgReadingTime.avgMonth / 60 | numFilter}}
                        {{lang('groupHomeReadingMonthUnit2',language)}}
                    </p>
                </Col>
            </Row>
            <br>
            <Row>
                <Col span="24" :style="{borderTop: '1px solid #E8E9F2'}">
                    <br>
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeReadingTrendText',language)}}</p>
                    <p :style="{marginTop: '10px',fontSize: '18px',color:'#595959',fontWeight:'bold'}">
                        {{readingPreferences.join(",")}}
                    </p>
                </Col>
            </Row>
        </Card>

        <br/>
        <Card>
            <Spin size="large" fix v-if="funcDataLoading"></Spin>
            <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                {{lang('groupHomeModuleText2',language)}}
            </p>
            <Row>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeFuncText0',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{learningWords}}
                        <span :style="{fontSize:'18px'}">{{lang('groupHomeFuncUnitText3',language)}}</span>
                    </p>
                </Col>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeFuncText1',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgReadingEvalSentences}}
                        <span :style="{fontSize:'18px'}">{{lang('groupHomeFuncUnitText1',language)}}</span>
                    </p>
                </Col>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}" v-if="hideModule.indexOf('5') === -1">
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeFuncText2',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgMbAccessTimes}}
                        <span :style="{fontSize:'18px'}">{{lang('groupHomeFuncUnitText0',language)}}</span>
                    </p>
                </Col>
                <Col span="6" v-if="hideModule.indexOf('6') === -1">
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeFuncText3',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgQgamePassedPoints}}
                        <span :style="{fontSize:'18px'}">{{lang('groupHomeFuncUnitText2',language)}}</span>
                    </p>
                </Col>
            </Row>
        </Card>
        <br>
        <!--榜单部分-->
        <Row :gutter="2">

            <!--阅读排行榜-->
            <Col span="8">
                <Card>
                    <Spin size="large" fix v-if="rankingDataLoading"></Spin>
                    <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                        {{lang('groupHomeModuleText3',language)}}
                    </p>
                    <Row>
                        <Col span="10">
                            <div class="rankTitle">
                                {{lang('groupHomeRankingHeaderTitleText1',language)}}
                            </div>
                        </Col>
                        <Col span="7">
                            <div class="rankTitle">
                                {{lang('groupHomeRankingHeaderTitleText3',language)}}
                            </div>
                        </Col>
                        <Col span="7">
                            <div class="rankTitle">
                                {{lang('groupHomeRankingHeaderTitleText5',language)}}
                            </div>
                        </Col>
                    </Row>
                    <br>
                    <Row v-for="(item,index) in readingRanking" :key="index">
                        <Col span="10">
                            <div>
                                <Avatar :src="item.avatar === ''?defaultAvatar:item.avatar"
                                        :style="{float:'left'}" size="large"/>
                                <p class="nickname">
                                    {{item.nickname}}
                                </p>
                            </div>
                        </Col>
                        <Col span="7">
                            <div :style="{marginTop:'10px'}">
                                <p>{{item.rankValue1}}</p>
                            </div>
                        </Col>
                        <Col span="7">
                            <div :style="{marginTop:'10px'}">
                                <p>{{item.rankValue2 / 60 | numFilter}}</p>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Col>

            <!--收听排行榜-->
            <Col span="8" v-if="hideModule.indexOf('7') === -1">
                <Card>
                    <Spin size="large" fix v-if="rankingDataLoading"></Spin>
                    <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                        {{lang('groupHomeModuleText5',language)}}
                    </p>
                    <Row>
                        <Col span="10">
                            <div class="rankTitle">
                                {{lang('groupHomeRankingHeaderTitleText1',language)}}
                            </div>
                        </Col>
                        <Col span="7">
                            <div class="rankTitle">
                                {{lang('groupHomeRankingHeaderTitleText9',language)}}
                            </div>
                        </Col>
                        <Col span="7">
                            <div class="rankTitle">
                                {{lang('groupHomeRankingHeaderTitleText11',language)}}
                            </div>
                        </Col>
                    </Row>
                    <br>
                    <Row v-for="(item,index) in ugcMBListeningRanking" :key="index">
                        <Col span="10">
                            <div>
                                <Avatar :src="item.avatar === ''?defaultAvatar:item.avatar"
                                        :style="{float:'left'}" size="large"/>
                                <div class="nickname">
                                    {{item.nickname}}
                                </div>
                            </div>
                        </Col>
                        <Col span="7">
                            <div :style="{marginTop:'10px'}">
                                <p>{{item.rankValue1}}</p>
                            </div>
                        </Col>
                        <Col span="7">
                            <div :style="{marginTop:'10px'}">
                                <p>{{item.rankValue2}}</p>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Col>

            <!--通关排行榜-->
            <Col span="8" v-if="hideModule.indexOf('8') === -1">
                <Card>
                    <Spin size="large" fix v-if="rankingDataLoading"></Spin>
                    <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                        {{lang('groupHomeModuleText7',language)}}
                    </p>
                    <Row>
                        <Col span="10">
                            <div class="rankTitle">
                                {{lang('groupHomeRankingHeaderTitleText1',language)}}
                            </div>
                        </Col>
                        <Col span="7">
                            <div class="rankTitle">
                                {{lang('groupHomeRankingHeaderTitleText13',language)}}
                            </div>
                        </Col>
                        <Col span="7">
                            <div class="rankTitle">
                                {{lang('groupHomeRankingHeaderTitleText15',language)}}
                            </div>
                        </Col>
                    </Row>
                    <br>
                    <Row v-for="(item,index) in quizGameRanking" :key="index">
                        <Col span="10">
                            <div>
                                <Avatar :src="item.avatar === ''?defaultAvatar:item.avatar"
                                        :style="{float:'left'}" size="large"/>
                                <div class="nickname">
                                    {{item.nickname}}
                                </div>
                            </div>
                        </Col>
                        <Col span="7">
                            <div :style="{marginTop:'10px'}">
                                <p>{{item.rankValue1}}</p>
                            </div>
                        </Col>
                        <Col span="7">
                            <div :style="{marginTop:'10px'}">
                                <p>{{item.rankValue2}}</p>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>
<script>
    var _hmt = _hmt || [];
    (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?4537bce4a2128c98b476fa3bc3b18f86";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
    })();


    import {lang} from "@/utils/language.js";
    import store from '@/store/index.js';
    import config from '@/utils/config.js';
    import ContentHeader from '@/components/ContentHeader.vue';
    import {get} from '@/utils/net.js';

    export default {
        name: 'Home',
        store,
        components: {
            ContentHeader,
        },
        data() {
            return {
                headerTipArr:[],
                lang: lang,
                stateLang: '',
                defaultAvatar: config.defaultAvatar,
                readingDataLoading: false,
                funcDataLoading: false,
                rankingDataLoading: false,
                userId: '',
                scopeType: '',
                scope: '',
                readingPreferences: [],
                avgReadingTime: {
                    avg: '',
                    avgDay: '',
                    avgMonth: '',
                    avgWeek: '',
                },
                avgReadingCompletedBooks: {
                    avg: '',
                    avgDay: '',
                    avgMonth: '',
                    avgWeek: '',
                },
                avgReadingBooks:{
                    avg: '',
                    avgDay: '',
                    avgMonth: '',
                    avgWeek: '',
                },
                avgReadingWords: {
                    avg: '',
                    avgDay: '',
                    avgMonth: '',
                    avgWeek: '',
                },
                learningWords: '',
                avgMbAccessTimes: '',
                avgQgamePassedPoints: '',
                avgReadingEvalSentences: '',
                quizGameRanking: [],
                ugcMBListeningRanking: [],
                readingRanking: [],
                ret: {},
            }
        },
        mounted() {
            this.loadHeaderTipArr();
            this.getMainReadingData();
            this.getMainFuncData();
            this.getRankingData();
        },
        methods: {
            loadHeaderTipArr() {
                this.headerTipArr.splice(0);
                var titleArr = this.lang('groupHomeHeaderTipTitle', this.language);
                var contentArr = this.lang('groupHomeHeaderTipContent', this.language);
                for (var i = 0; i < titleArr.length; i++) {
                    var item = {};
                    item.title = titleArr[i];
                    item.content = contentArr[i];
                    if (JSON.stringify(item) !== '') {
                        this.headerTipArr.push(item);
                    }
                }
            },
            //获取阅读情况数据
            getMainReadingData() {
                let that = this;
                that.readingDataLoading = true;
                get({
                    context: that,
                    url: '/open/reading/primary',
                    params: {
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        that.avgReadingBooks = retMap.avgReadingBooks;
                        that.readingPreferences = retMap.readingPreferences;
                        that.avgReadingTime = retMap.avgReadingTime;
                        that.avgReadingCompletedBooks = retMap.avgReadingCompletedBooks;
                        that.avgReadingWords = retMap.avgReadingWords;
                        that.readingDataLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.readingDataLoading = false;
                    }
                })
            },

            //获取各项功能情况
            getMainFuncData() {
                let that = this;
                that.funcDataLoading = true;
                get({
                    context: that,
                    url: '/open/rfunc/primary',
                    params: {
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        that.learningWords = retMap.learningWords;
                        that.avgMbAccessTimes = retMap.avgMbAccessTimes;
                        that.avgQgamePassedPoints = retMap.avgQgamePassedPoints;
                        that.avgReadingEvalSentences = retMap.avgReadingEvalSentences;
                        that.funcDataLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.funcDataLoading = false;
                    }
                });
            },

            //获取榜单数据
            getRankingData() {
                let that = this;
                that.rankingDataLoading = true;
                get({
                    context: that,
                    url: '/open/ranking/primary',
                    params: {
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        that.readingRanking = retMap.readingRanking;
                        that.ugcMBListeningRanking = retMap.ugcMBListeningRanking;
                        that.quizGameRanking = retMap.quizGameRanking;
                        that.rankingDataLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.rankingDataLoading = false;
                    }
                });
            },
        },
        computed: {
            hideModule:function () {
                return store.getters.getHideModule;
            },
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            },
            hideModule:function () {
                return store.getters.getHideModule;
            }
        },
        watch: {
            stateLang: function () {

            }
        },
        filters :{
            numFilter(value) {
                // 截取当前数据到小数点后两位
                let realVal = parseFloat(value).toFixed(2);
                // num.toFixed(2)获取的是字符串
                return parseFloat(realVal);
            }
        }

    }
</script>

<style scoped>
    .rankTitle {
        color: #4F6B87;
        font-weight: bold;
        text-align: left;
        margin-left: 10px;
    }
    .nickname{
        float: left;
        margin-top: 10px;
        width: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
    }
</style>
